import React, { useState } from "react";
import { Star } from "lucide-react";

/**
 * Interactive or read-only 5-star rating. When `onChange` is provided the
 * stars are clickable. Otherwise renders a static display with half-star
 * support via the fill width.
 */
export default function RatingStars({ value = 0, onChange, size = 16, showNumber = false, testid = "rating" }) {
  const [hover, setHover] = useState(0);
  const interactive = typeof onChange === "function";
  const active = interactive && hover > 0 ? hover : value;

  return (
    <div className="inline-flex items-center gap-1" data-testid={testid}>
      <div className="inline-flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((n) => {
          const filled = active >= n;
          const half = !filled && active >= n - 0.5;
          const common = {
            onMouseEnter: interactive ? () => setHover(n) : undefined,
            onMouseLeave: interactive ? () => setHover(0) : undefined,
            onClick: interactive ? () => onChange(n) : undefined,
            style: {
              cursor: interactive ? "pointer" : "default",
              color: filled || half ? "var(--vip-gold)" : "rgba(255,255,255,0.2)",
            },
            "data-testid": `${testid}-star-${n}`,
          };
          return (
            <Star
              key={n}
              size={size}
              strokeWidth={1.4}
              fill={filled ? "var(--vip-gold)" : "transparent"}
              {...common}
            />
          );
        })}
      </div>
      {showNumber && value > 0 && (
        <span className="text-xs font-serif" style={{ color: "var(--text-primary)" }} data-testid={`${testid}-value`}>
          {Number(value).toFixed(1)}
        </span>
      )}
    </div>
  );
}
